import { Component, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BooleanValueAccessorDirective, ValidateDirective } from '@skylab-angular-shared/ui';
import { FiscalDeviceVatRatesParametersMappingModelWrapper } from '../../fiscal-device-dialog-grid-item';

@Component({
    selector: 'skl-fiscal-device-dialog-grid-technical-zero',
    template: `
    @if (this.entity.technicalZero) {
        <ins-checkbox
            class="display--flex display--justify-center checkbox--checked-validations"
            [(ngModel)]="entity.technicalZero"
            [sklValidate]="'technicalZero.' + entity.parameters.sun">
        </ins-checkbox>
    } @else {
        <ins-checkbox
            class="display--flex display--justify-center checkbox--checked-validations"
            [(ngModel)]="entity.technicalZero">
        </ins-checkbox>
    }`,
    imports: [BooleanValueAccessorDirective, FormsModule, ValidateDirective]
})
export class FiscalDeviceDialogGridTechnicalZeroComponent {
    @Input() public entity!: FiscalDeviceVatRatesParametersMappingModelWrapper;
}
